import {
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER,
  DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS,
} from '../DocumentEditAccessActionModal.constants'

export const ACCESS_FIELD_NAMES = {
  admins: `${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS}.${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS}`,
  landlords: `${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS}.${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS}`,
  managers: `${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS}.${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER}`,
  tenants: `${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS}.${DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS}`,
}

export const ACCESS_ROLE_BY_FIELD = {
  admins: DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_ADMINS,
  landlords: DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_LANDLORDS,
  managers: DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_MANAGER,
  tenants: DOCUMENT_EDIT_ACCESS_FIELD_NAME_ACCESS_TENANTS,
}
